import React from 'react';
import { IProposta } from '../../../utility/IProposta';
import CabecalhoDiaListaDemandas from '../CabecalhoDiaListaDemandas';
import CardDemanda from '../../CardDemanda';
import { Container, ContentArea, ListaCards } from './styles';

interface DiaListaDemandasProps {
  data: Date | string;
  propostas: IProposta[];
}

export default function DiaListaDemandas({ data, propostas }: DiaListaDemandasProps) {
  const converterParaDate = (valor: Date | string): Date => {
    if (valor instanceof Date) return valor;
    const str = valor as string;
    const match = str.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (match) {
      const year = Number(match[1]);
      const month = Number(match[2]) - 1;
      const day = Number(match[3]);
      return new Date(year, month, day);
    }
    return new Date(str);
  };

  const dataConvertida = converterParaDate(data);
  const quantidadeDemandas = propostas.length;

  return (
    <Container>
      <CabecalhoDiaListaDemandas 
        data={dataConvertida} 
        qtdDemandas={quantidadeDemandas} 
      />
      <ContentArea>
        <ListaCards>
          {propostas.map((proposta) => (
            <CardDemanda key={proposta.id_proposta} proposta={proposta} />
          ))}
        </ListaCards>
      </ContentArea>
    </Container>
  );
}
